import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

const SESSION_DURATION = 120 * 60 * 1000; // 120 minutes in milliseconds

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const sessionStart = localStorage.getItem("sessionStart");
    if (sessionStart) {
      const isValid = Date.now() - parseInt(sessionStart) < SESSION_DURATION;
      setIsAuthenticated(isValid);
      if (!isValid) localStorage.removeItem("sessionStart");
    }
  }, []);

  const login = (callback) => {
    localStorage.setItem("sessionStart", Date.now().toString());
    setIsAuthenticated(true);
    callback();
  };

  const logout = (callback) => {
    localStorage.removeItem("sessionStart");
    setIsAuthenticated(false);
    callback();
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
